import { io, type Socket } from 'socket.io-client';

// Token provider — set by AuthContext after authentication state changes.
let _getToken: (() => string | null) | null = null;

export function setSocketTokenProvider(fn: () => string | null): void {
  _getToken = fn;
}

let _socket: Socket | null = null;

function buildSocket(): Socket {
  return io({
    path: '/socket.io/',
    autoConnect: false,
    reconnection: true,
    reconnectionDelay: 1_000,
    reconnectionDelayMax: 10_000,
    // auth as a callback: called before every connect/reconnect attempt,
    // so fresh tokens are picked up automatically after a silent refresh.
    auth: (cb: (data: { token: string | null }) => void) => {
      cb({ token: _getToken?.() ?? null });
    },
  });
}

export function getSocket(): Socket {
  if (!_socket) _socket = buildSocket();
  return _socket;
}

export function connectSocket(): void {
  getSocket().connect();
}

export function disconnectSocket(): void {
  const s = _socket;
  if (s?.connected) s.disconnect();
}
